// src/utils/linkUtils.tsx
import { Link } from "@mui/material";

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// ../../node_modules/@mui/utils/deepmerge/deepmerge.js
function isPlainObject(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (key === "__proto__") {
        return;
      }
      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

// src/utils/linkUtils.tsx
import React from "react";
import { jsx } from "react/jsx-runtime";
var getLinkBehavior = (RouterLink) => {
  const LinkBehavior = React.forwardRef((props, ref) => {
    const { href, ...rest } = props;
    return /* @__PURE__ */ jsx(RouterLink, { ref, ...rest, to: href });
  });
  LinkBehavior.displayName = "LinkBehaviorWrapper";
  return LinkBehavior;
};
var getRouterOverriddenTheme = (RouterLink, overrides = {}) => deepmerge(
  {
    components: {
      MuiLink: {
        defaultProps: {
          component: getLinkBehavior(RouterLink)
        }
      },
      MuiButtonBase: {
        defaultProps: {
          LinkComponent: getLinkBehavior(RouterLink)
        }
      }
    }
  },
  overrides
);
var MaybeLink = ({ children, href, ...rest }) => {
  return href?.length ? /* @__PURE__ */ jsx(Link, { href, ...rest, children }) : children;
};

export {
  getLinkBehavior,
  getRouterOverriddenTheme,
  MaybeLink
};
/*! Bundled license information:

@mui/utils/index.js:
  (**
   * @mui/utils v5.15.11
   *
   * @license MIT
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)
*/
//# sourceMappingURL=chunk-MNYJQFCA.js.map